import {API_BASE_URL} from "../../../config/constants";
import { postRequest } from '../../API'
/*********************************************************
* Function Name : list
* Description   : Get list of due users 
* By            : Afsar Ali
* Date          : 28-11-2024 
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/users/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addeditdata
* Description   : Get list of add/edit data 
* By            : Afsar Ali
* Date          : 28-11-2024 
*********************************************************/
export const addeditdata = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/customers-due/addeditdata`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : collectAmount
* Description   : 
* By            : Afsar Ali
* Date          : 31-05-2025
*********************************************************/
export const collectAmount = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/users/collect-due`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : settleAmount
* Description   : 
* By            : Afsar Ali
* Date          : 31-05-2025
*********************************************************/
export const settleAmount = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/users/settle-due`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : updateDueAmount
* Description   : Get list of add/edit data 
* By            : Afsar Ali
* Date          : 28-11-2024 
*********************************************************/
export const updateDueAmount = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/customers-due/update-due`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addCollection
* Description   : Add Collection
* By            : Afsar Ali
* Date          : 02-12-2024 
*********************************************************/
export const addCollection = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/users/update-collection`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addCollection
* Description   : Add Collection
* By            : Afsar Ali
* Date          : 30-07-2025
*********************************************************/
export const updateDueBalance = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/users/update-due-amount`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : attendanceList
* Description   : Get attendance list
* By            : Afsar Ali
* Date          : 06-01-2026
*********************************************************/
export const attendanceList = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/attendance/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
/*********************************************************
* Function Name : addNotes
* Description   : Add notes
* By            : Afsar Ali
* Date          : 12-01-2026
*********************************************************/
export const addNotes = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/attendance/add-notes`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : attendanceLocationList
* Description   : Get attendance location list
* By            : Afsar Ali
* Date          : 12-01-2026
*********************************************************/
export const attendanceLocationList = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/attendance/location-list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : attendanceSummery
* Description   : Get attendance summery
* By            : Afsar Ali
* Date          : 13-01-2026
*********************************************************/
export const attendanceSummery = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/attendance/summery`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
/*********************************************************
* Function Name : attendanceSummeryAgent
* Description   : Get attendance summery for agent
* By            : Afsar Ali
* Date          : 19-01-2026
*********************************************************/
export const attendanceSummeryAgent = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/attendance/agent-summery`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
/*********************************************************
* Function Name : updateInvoiceName
* Description   : Update invoice name
*********************************************************/
export const updateInvoiceName = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/account/users/update-invoice-name`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function